<style lang="less">
@import "../../styles/main.less";
</style>
<template>
  <div id="main" class="main" :class="{'main-hide-text': hideMenuText}">
    <div class="sidebar-menu-con" style="display: flex;height: 100%;">
      <sidebar-menu :hideMenuText="hideMenuText" :menuList="menuList" :iconSize="18"/>
    </div>
    <div class="main-header-con" :style="{paddingLeft: hideMenuText?'50px':'210px'}">
      <div class="main-header" style="margin-left: 10px;">
        <div class="navicon-con">
          <Button :style="{transform: 'rotateZ(' + (this.hideMenuText ? '-90' : '0') + 'deg)'}" type="text"
                  @click="toggleClick">
            <Icon type="md-menu" size="26"></Icon>
          </Button>
        </div>
        <div class="header-middle-con">
          <div class="main-breadcrumb">
            <breadcrumb-nav :currentPath="currentPath" style="color: #fff;"></breadcrumb-nav>
          </div>
        </div>
        <div class="header-avator-con">
          <div class="user-dropdown-menu-con">
            <Row type="flex" justify="end" align="middle" class="user-dropdown-innercon">
              <Dropdown trigger="click" @on-click="handleClickUserDropdown">
                <a href="javascript:void(0)">
                  <span class="main-user-name" style="color: white;">{{ display }}</span>
                  <Icon type="md-arrow-dropdown"/>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem name="loginout">退出登录</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Avatar :src="avatorPath" style="background: #ffffff;margin-left: 10px;"></Avatar>
            </Row>
          </div>
        </div>
      </div>
    </div>
    <div class="single-page-con" :style="{paddingLeft: hideMenuText?'60px':'200px'}">
      <div class="single-page">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" :key="key">
          </router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive">
        </router-view>
      </div>
    </div>
  </div>
</template>
<script>
import sidebarMenu from '../../menu.vue'
import breadcrumbNav from '@/components/breadcrumb-nav'
import axios from 'axios'
import { mapState } from 'vuex'
import Watermark from '../../libs/warterMark'

export default {
  components: {
    sidebarMenu,
    breadcrumbNav
  },
  data () {
    return {
      currentPageName: '',
      hideMenuText: false,
      display: this.$util.getItem('display'),
      avatorPath: ''
    }
  },
  computed: {
    ...mapState([
      'pageOpenedList',
      'currentPath',
      'menuList'
    ]),
    key () {
      return this.$route.path
    }
  },
  methods: {
    // 导航栏收缩
    toggleClick () {
      this.hideMenuText = !this.hideMenuText
    },
    // 退出
    handleClickUserDropdown () {
      axios.get(`${this.$util.logout}/${this.$util.getItem('loginuser')}`)
        .then(res => {
          this.$util.rmItem('loginuser');
          this.$util.rmItem('jwt');
          this.$util.rmItem('auth');
          this.$util.rmItem('display');
          this.$util.rmItem('avatar');
          this.$util.rmItem('TOKEN');
          localStorage.clear()
          this.$router.push({
            path: `/login?redirect=${this.$router.currentRoute.fullPath}`
          })
        })
        .catch(error => {
          this.$util.error(this, error)
        })
    },
    init () {
      // 问候信息相关
      if (!this.$util.getItem('hasGreet')) {
        let now = new Date()
        let hour = now.getHours()
        let greetingWord = {
          title: '',
          words: ''
        }
        let userName = this.$util.getItem('display')
        if (hour < 6) {
          greetingWord = {
            title: '凌晨好~' + userName,
            words: '早起的鸟儿有虫吃~'
          }
        } else if (hour >= 6 && hour < 9) {
          greetingWord = {
            title: '早上好~' + userName,
            words: '来一杯咖啡开启美好的一天~'
          }
        } else if (hour >= 9 && hour < 12) {
          greetingWord = {
            title: '上午好~' + userName,
            words: '工作要加油哦~'
          }
        } else if (hour >= 12 && hour < 14) {
          greetingWord = {
            title: '中午好~' + userName,
            words: '午饭要吃饱~'
          }
        } else if (hour >= 14 && hour < 17) {
          greetingWord = {
            title: '下午好~' + userName,
            words: '下午也要活力满满哦~'
          }
        } else if (hour >= 17 && hour < 19) {
          greetingWord = {
            title: '傍晚好~' + userName,
            words: '致上班的你，辛苦了~'
          }
        } else if (hour >= 19 && hour < 21) {
          greetingWord = {
            title: '晚上好~' + userName,
            words: '工作之余品一品书香吧~'
          }
        } else {
          greetingWord = {
            title: '深夜好~' + userName,
            words: '夜深了，注意休息哦~'
          }
        }
        this.$Notice.config({
          top: 130
        })
        this.$Notice.info({
          title: greetingWord.title,
          desc: greetingWord.words,
          duration: 4,
          name: 'greeting'
        })
        this.$util.setItem('hasGreet', 1)
      }
    }
  },
  mounted () {
    let userName = this.$util.getItem('display')
    let loginuser = this.$util.getItem('loginuser')
    Watermark.set(userName + '(' + loginuser + ')')
    this.$store.commit('Breadcrumbset', this.$route.matched[1].name)
    this.$store.state.currentPageName = this.$route.matched[1].name
    if (localStorage.getItem('pageOpenedList')) {
      this.$store.state.pageOpenedList = JSON.parse(localStorage.getItem('pageOpenedList'))
    } else {
      this.$store.state.pageOpenedList = [{
        title: '首页',
        path: '',
        name: 'home_index'
      }]
    }
    this.init()
  },
  created () {
    // 权限菜单过滤相关
    this.$store.commit('Menulist')
    axios.defaults.headers.common['Authorization'] = this.$util.getItem('jwt')
    this.avatorPath = this.$util.getItem('avatar')
  }
}
</script>



// WEBPACK FOOTER //
// main.vue?4ae441c9